/**
 * oRPC Chat Contract
 * Defines the chat API contract using oRPC contract system
 */

import { oc, eventIterator } from "@orpc/contract";
import { z } from "zod";
import {
  messageStructureSchemas,
  authenticationSchemas,
  healthSchemas,
} from "../index.js";

// Chat contract definition
export const chatContract = oc.router({
  // Health endpoint
  health: oc.router({
    check: oc
      .route({
        method: "POST",
        path: "/health/check",
      })
      .output(healthSchemas.HealthResponse),
  }),

  // Authentication endpoints
  auth: oc.router({
    getLoginUrl: oc
      .route({
        method: "POST",
        path: "/auth/getLoginUrl",
      })
      .input(
        z.object({
          state: z.string().optional().default("default"),
        }),
      )
      .output(authenticationSchemas.LoginUrlResponse),

    getCurrentUser: oc
      .route({
        method: "POST",
        path: "/auth/getCurrentUser",
      })
      .output(authenticationSchemas.UserResponse),
  }),

  // Chat endpoints
  chat: oc.router({
    sendMessage: oc
      .route({
        method: "POST",
        path: "/chat/sendMessage",
      })
      .input(messageStructureSchemas.SendMessageRequest)
      .output(messageStructureSchemas.ChatMessage),

    getMessages: oc
      .route({
        method: "POST",
        path: "/chat/getMessages",
      })
      .input(messageStructureSchemas.GetMessagesRequest)
      .output(messageStructureSchemas.MessageListResponse),

    subscribeToMessages: oc
      .route({
        method: "POST",
        path: "/chat/subscribeToMessages",
      })
      .input(messageStructureSchemas.SubscribeToMessagesRequest)
      .output(eventIterator(messageStructureSchemas.ChatMessage)),
  }),
});

export type ChatContract = typeof chatContract;
